module.exports = __webpack_public_path__ + "assets/img/pt-80d821e1.png";